/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountStatementListOutputDto { 
    id?: number;
    productName?: string | null;
    productType?: string | null;
    accountNumber?: string | null;
    date?: string;
    referenceNumber?: string | null;
    accountId?: number;
    transactionId?: string | null;
    description?: string | null;
    debit?: number;
    credit?: number;
    balance?: number;
    openingBalance?: number;
    closingBalance?: number;
    type?: string | null;
    accountType?: string | null;
    allowedAsGuarantor?: boolean;
    allowedAsCollateral?: boolean;
    blockedAmount?: number | null;
    sessionDate?: string;
    transactionType?: string | null;
    transactor?: string | null;
}

